import type {WritableAtom} from 'jotai';
import {atom} from 'jotai';

export function atomWithoutDefault<Value>(key: string): WritableAtom<Value, [() => Value], void> {
    const sentinel = Symbol();
    const internal = atom<typeof sentinel | Value>(sentinel);

    return atom(
        get => {
            const value = get(internal);
            if (value === sentinel) {
                throw new Error(`Atom without default "${key}" must first be initialized`);
            }
            return value;
        },
        (_, set, arg: () => Value) => {
            set(internal, arg);
        }
    );
}
